export enum TipoPedidoSapEnum {
  CARVAO = 'CARVAO',
  CATALISADOR = 'CATALISADOR',
  ESCORIA = 'ESCORIA',
  MINERIO = 'MINERIO',
  OUTROS = 'OUTROS',
  PLACA = 'PLACA',
}

export enum PedidoSapScopeEnum {
  ComFornecedor = 'ComFornecedor',
}

export enum PedidosSapEventsEnum {
  Atualizado = 'pedido-atualizado',
  BagCriado = 'bag-cadastrado',
  Criado = 'pedido-cadastrado',
  PedidoCompraRegistrado = 'pedido-compra-registrado',
  Removido = 'pedido-removido',
}
